<template>
  <div class="recipe_add">
    <br />

    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: 'SignCheck' }">申请处方</el-breadcrumb-item>
      <el-breadcrumb-item>病情主诉</el-breadcrumb-item>
    </el-breadcrumb>
    <br />

    <hr />
    <!--
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="申请处方" name="first">
        <el-container>
          <el-header>
          </el-header>
    -->

    <el-main>
      <div class="form-region-header font-30" >复诊</div>
      <br/>
      <el-form ref="formModels" :model="formModels"  label-width="100px">
        <table width="100%">
          <tr>
            <td>
              <el-form-item label="是否复诊">
                <el-radio v-model="formModels.needNextConsult" label="是">是</el-radio>
                <el-radio v-model="formModels.needNextConsult" label="否">否</el-radio>
              </el-form-item>
            </td>

            <td>
              <el-form-item label="首诊医疗机构">
                <el-input v-model="formModels.firstHospitalName" name="test" auto-complete="on" placeholder="请输入首诊医院名称" style="width:250px"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>
              <el-form-item label="首诊日期">
                <el-date-picker
                  v-model="formModels.firstConsultDate"
                  :picker-options="pickerOptions"
                  type="date"
                  placeholder="请选择首诊日期"
                ></el-date-picker>
              </el-form-item>
            </td>
            <td>
              <el-form-item label="处方日期">
                <el-date-picker
                  v-model="formModels.recipeDate"
                  :picker-options="pickerOptions"
                  type="date"
                ></el-date-picker>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>
              <!--
              <el-form-item label="上传处方或病例（选填）">
                <el-upload
                  class="upload-demo"
                  drag
                  action="https://jsonplaceholder.typicode.com/posts/"
                  multiple
                >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">
                    将文件拖到此处，或
                    <em>点击上传</em>
                  </div>
                  <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
                </el-upload>
              </el-form-item>
              -->
            </td>
          </tr>
        </table>
      </el-form>
    </el-main>
    <el-main>
      <div class="form-region-header font-30">现病史（常见症状）</div>
      <el-form ref="formModels" :model="formModels" label-width="100px">
        <table width="100%">
          <tr>
            <td>
              <el-form-item label="常见病症">
                <el-checkbox-group
                  v-model="formModels.cbgCommons"
                  size="mini"
                  @change="updateillDesc"
                >
                  <el-checkbox-button
                    v-for="val in formBinds.cbgCommons"
                    :label="val"
                    :key="val"
                  >{{val}}</el-checkbox-button>
                </el-checkbox-group>
              </el-form-item>
            </td></tr>
            <tr>
            <td>
              <el-form-item label="呼吸系统">
                <el-checkbox-group
                  v-model="formModels.cbgBreaths"
                  size="mini"
                  @change="updateillDesc"
                >
                  <el-checkbox-button
                    v-for="val in formBinds.cbgBreaths"
                    :label="val"
                    :key="val"
                  >{{val}}</el-checkbox-button>
                </el-checkbox-group>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>
              <el-form-item label="消化系统">
                <el-checkbox-group
                  v-model="formModels.cbgDigest"
                  size="mini"
                  @change="updateillDesc"
                >
                  <el-checkbox-button
                    v-for="val in formBinds.cbgDigest"
                    :label="val"
                    :key="val"
                  >{{val}}</el-checkbox-button>
                </el-checkbox-group>
              </el-form-item>
            </td></tr>
            <tr>
            <td>
              <el-form-item label="心脑血管">
                <el-checkbox-group
                  v-model="formModels.cbgVessel"
                  size="mini"
                  @change="updateillDesc"
                >
                  <el-checkbox-button
                    v-for="val in formBinds.cbgVessel"
                    :label="val"
                    :key="val"
                  >{{val}}</el-checkbox-button>
                </el-checkbox-group>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>
              <el-form-item label="男科疾病">
                <el-checkbox-group v-model="formModels.cbgMen" size="mini" @change="updateillDesc">
                  <el-checkbox-button
                    v-for="val in formBinds.cbgMen"
                    :label="val"
                    :key="val"
                  >{{val}}</el-checkbox-button>
                </el-checkbox-group>
              </el-form-item>
            </td></tr>
            <tr>
            <td>
              <el-form-item label="妇科疾病">
                <el-checkbox-group
                  v-model="formModels.cbgWomen"
                  size="mini"
                  @change="updateillDesc"
                >
                  <el-checkbox-button
                    v-for="val in formBinds.cbgWomen"
                    :label="val"
                    :key="val"
                  >{{val}}</el-checkbox-button>
                </el-checkbox-group>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>
              <el-form-item label="五官口腔">
                <el-checkbox-group v-model="formModels.cbgFace" size="mini" @change="updateillDesc">
                  <el-checkbox-button
                    v-for="val in formBinds.cbgFace"
                    :label="val"
                    :key="val"
                  >{{val}}</el-checkbox-button>
                </el-checkbox-group>
              </el-form-item>
            </td></tr>
            <tr>
            <td>
              <el-form-item label="风湿骨病">
                <el-checkbox-group v-model="formModels.cbgBone" size="mini" @change="updateillDesc">
                  <el-checkbox-button
                    v-for="val in formBinds.cbgBone"
                    :label="val"
                    :key="val"
                  >{{val}}</el-checkbox-button>
                </el-checkbox-group>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>
              <el-form-item label="皮肤疾病">
                <el-checkbox-group v-model="formModels.cbgSkin" size="mini" @change="updateillDesc">
                  <el-checkbox-button
                    v-for="val in formBinds.cbgSkin"
                    :label="val"
                    :key="val"
                  >{{val}}</el-checkbox-button>
                </el-checkbox-group>
              </el-form-item>
            </td>
          </tr>
        </table>
      </el-form>
    </el-main>
    <el-main>
      <div class="form-region-header font-30">病情主述</div>
      <el-input type="textarea" :rows="5" placeholder v-model="formModels.illDesc1"></el-input>
      <el-input type="textarea" :rows="5" placeholder v-model="formModels.illDesc2"></el-input>
    </el-main>
    <el-footer>
      <el-button @click="gotomodify">上一步</el-button>
      <el-button type="primary" @click="onSubmit('form')">下一步</el-button>
    </el-footer>
    <!--
        </el-container>
      </el-tab-pane>
    </el-tabs>
    -->
  </div>
</template>

<script>
import qs from "qs";
export default {
  name: "RecipeAdd2",
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          var times = Date.now() - 24 * 60 * 60 * 1000;
          return time.getTime() > times;
        }
      },
      activeName: "first",
      formModels: {
        needNextConsult: "是",
        firstHospitalName: "",
        firstConsultDate: "",
        recipeDate:"",
        cbgCommons: [],
        cbgBreaths: [],
        cbgDigest: [],
        cbgVessel: [],
        cbgMen: [],
        cbgWomen: [],
        cbgFace: [],
        cbgBone: [],
        cbgSkin: [],
        illDesc1: "",
        illDesc2: ""
      },
      // <input type="checkbox" id="sick\d+_\d+" onclick="funSickSelect\('sick\d+_\d+','([^']+).*$
      formBinds: {
        cbgCommons: [
          "感冒",
          "咳嗽",
          "咽喉痛",
          "发烧",
          "腹泻",
          "高血压",
          "糖尿病",
          "胃痛胃炎",
          "胃酸烧心",
          "支气管炎",
          "咽喉炎",
          "尿路感染",
          "牙疼",
          "皮肤过敏",
          "皮肤感染"
        ],
        cbgBreaths: [
          "感冒",
          "流行性感冒",
          "支气管炎",
          "肺炎",
          "鼻炎",
          "咽炎",
          "哮喘",
          "小儿感冒"
        ],
        cbgDigest: [
          "胃炎",
          "肠炎",
          "胃溃疡",
          "胃痛胃炎",
          "胃酸烧心",
          "阑尾炎",
          "胆囊炎",
          "幽门螺旋杆菌",
          "消化不良",
          "肝炎",
          "脂肪肝",
          "胆结石",
          "便秘"
        ],
        cbgVessel: [
          "高血压",
          "冠心病",
          "心脏病",
          "心肌炎",
          "动脉硬化",
          "心肌梗塞",
          "高血糖",
          "高血脂",
          "心绞痛",
          "心律失常"
        ],
        cbgMen: ["男性性功能障碍", "前列腺炎", "前列腺增生", "排尿困难"],
        cbgWomen: [
          "子宫肌瘤",
          "小叶增生",
          "卵巢囊肿",
          "盆腔炎",
          "宫颈炎",
          "阴道炎",
          "月经不调"
        ],
        cbgFace: [
          "牙疼",
          "牙龈炎",
          "中耳炎",
          "麦粒肿",
          "结膜炎",
          "青光眼",
          "鼻炎",
          "鼻窦炎"
        ],
        cbgBone: [
          "风湿性关节炎",
          "内风湿关节炎",
          "骨关节炎",
          "痛风",
          "骨质增生",
          "跌打损伤",
          "颈椎病",
          "腰痛"
        ],
        cbgSkin: [
          "皮肤感染",
          "烧烫伤",
          "疖肿",
          "毛囊肿"
        ]
      },

      initRecipeApi: "http://121.196.220.228:30002/initRecipe",
      rules: {
        name: [
          { required: true, message: "请输入患者姓名", trigger: "blur" },
          { min: 2, max: 10, message: "长度在 2 到 10 个字符", trigger: "blur" }
        ],
        medicine: [
          { required: true, message: "请选择药品名字", trigger: "change" }
        ]
      }
    };
  },
  props: {
    msg: String
  },
  methods: {
    gotomodify() {
      this.$router.replace("/RecipeAdd1");
    },
    gotonext() {
      this.$router.replace("/RecipeAdd3");
    },
    updateillDesc() {
      // 把当前值刷新到 illDesc1 框里面
      let allChecked = [];

      for (let key in this.formModels) {
        //console.log(key);
        if (
          [
            "cbgCommons",
            "cbgBreaths",
            "cbgDigest",
            "cbgVessel",
            "cbgMen",
            "cbgWomen",
            "cbgFace",
            "cbgBone",
            "cbgSkin"
          ].includes(key)
        )
          allChecked = allChecked.concat(this.formModels[key]);
      }
      //console.log(allChecked.join(","));
      this.formModels.illDesc1 = allChecked.join(",");
      this.formModels.illDesc2 = allChecked.join(",");
    },
    //handleClick(tab, event) {
    //    console.log(tab, event);
    //},
    onSubmit(formName) {
      console.log(formName);
      var phoneNumber = sessionStorage.getItem("userPhone");
      //!!!!!
      //phoneNumber='13000000000';
      //console.log('phone '+phoneNumber);

      let tzoffset = new Date().getTimezoneOffset() * 60000;
      var firstCheckDate = new Date(this.formModels.firstConsultDate - tzoffset)
      .toISOString().slice(0, 10);
      
      var recipeDateTime = new Date(this.formModels.recipeDate);

      var recipeDate = new Date(this.formModels.recipeDate - tzoffset)
      .toISOString().slice(0, 10);
      
      //console.log(new Date(this.formModels.firstConsultDate - tzoffset));
      var selectedDate=new Date(this.formModels.firstConsultDate);
      var recipeDatetoCompare = new Date(this.formModels.recipeDate);
      var compareDate=new Date();
      var compareDate2=new Date();

      compareDate.setDate(compareDate.getDate()-6); 
      compareDate2.setDate(compareDate2.getDate()-7)
      //console.log(new Date()-6);
      //console.log(typeof(new Date()-6));
      if (
        !phoneNumber &&
        typeof phoneNumber != "undefined" &&
        phoneNumber != 0
      ) {
        alert("请先登记病人信息");
      } else if (selectedDate > compareDate) {
        alert("首诊时间必须在一周前！请修改首诊时间。");
      } else if (recipeDatetoCompare<compareDate2){
        alert("处方必须在7日内开据！请修改处方时间。");
      }else if (this.formModels.needNextConsult == "否") {
        alert("复诊患者才能使用远程处方");
      } else if (this.formModels.firstHospitalName.trim() == "") {
        alert("请正确填写首诊医疗机构");
      } else if (this.formModels.illDesc1.trim() == "") {
        alert("请正确填写病情");
      } else {
        //console.log(firstCheckDate);
        var datas = {
          customerPhone: phoneNumber,
          submitterName: "前台",
          isReCheck: this.formModels.needNextConsult == "是" ? 1 : 0,
          firstCheckHospital: this.formModels.firstHospitalName.trim(),
          firstCheckDate: firstCheckDate,
          firstCheckInfo: "",
          recipeDateTime:recipeDateTime,
          sickCategory: this.formModels.illDesc1.trim(),
          sickDetail: this.formModels.illDesc2.trim(),
          authToken: sessionStorage.getItem("authToken")
        };
        this.axios
          .post(this.initRecipeApi, qs.stringify(datas))
          .then(response => {
            let res = response.data;
            console.log(res);
            if (res.data.result == "success") {
              sessionStorage.setItem("recipeID", res.data.recipeID);
              console.log(sessionStorage);
              this.$router.replace("/RecipeAdd3");
            } else if (res.data.result == "fail") {
              alert(res.data.err.code);
            }
          }).catch((e) => { alert(e+"，登录超时，请重新登录");});
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  mounted() {
    if (sessionStorage.getItem("authToken") == null||sessionStorage.getItem("authToken").trim()==""){
      this.$router.replace("/Login");
    }
    this.formModels.recipeDate=new Date();
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
